// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__35ipN","boxTitle":"Qualiphy_boxTitle__3MvSn","box":"Qualiphy_box__2_C8d","toggleWrap":"Qualiphy_toggleWrap__1Kqln"};